import { SelfPosition } from "@pageBuilder/typings";

export class VerticalAlignmentRenderer {

    public getAlignmentBySelfPosition(position: SelfPosition): string {
        switch(position) {
            case "top":
                return "flex-start";
            case "center":
                return "center";
            default:
                return "flex-end";
        }
    }

    private getSelfPosition(value: string | undefined): SelfPosition {
        switch(value) {
            case "flex-start":
            case "start":
                return "top";
            case "center":
                return"center";
            case "flex-end":
            case "end":
                return "bottom";
            default:
                return "top";
        }
    }

}
